import { render, staticRenderFns } from "./personalSettings.vue?vue&type=template&id=09cd8b79&"
import script from "./personalSettings.vue?vue&type=script&lang=js&"
export * from "./personalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports